import React, { Component } from "react";
import { Field, reduxForm, change } from "redux-form";
import LeftArrow from "mdi-react/ArrowLeftIcon";
import { withRouter } from "react-router-dom";
import { render_field } from "../../../../utils/renderField";
import ErrorAlert from "../../../../components/alerts/components/BorderedAlertsWithIcons";
import LaptopImg from '../../../../img/laptop.png'

class ChangePassword extends React.Component {
 
  state = {
    uploadError: null,
    pwdLengthError: null,
    uppercaseError: null,
    lowercaseError: null,
    numberError: null,
    loading: null,
    loaded: null,
    errMsg: null,
    message: null,
  };

  componentDidMount() {
    const { firstName, lastName, password } = this.props.fields;
    this.props.dispatch(change("finalizeForm", "firstName", firstName));
    this.props.dispatch(change("finalizeForm", "lastName", lastName));
    this.props.dispatch(change("finalizeForm", "password", password));
  }

  componentDidUpdate(prevProps) {
    const { firstName, lastName, password } = this.props.fields;

    //prevProps.firstName !== firstName ? this.props.dispatch(change('finalizeForm', 'firstName', firstName)) : null
    if (prevProps.firstName !== firstName) {
      this.props.dispatch(change("finalizeForm", "firstName", firstName));
    }

    //prevProps.lastName !== lastName ? this.props.dispatch(change('finalizeForm', 'lastName', lastName)) : null
    if (prevProps.lastName !== lastName) {
      this.props.dispatch(change("finalizeForm", "lastName", lastName));
    }

    this.props.dispatch(change("finalizeForm", "password", password));
  }

  onSubmit() {
    const fields = this.props.fields;
    // delete fields.password

    this.setState({
      loading: true,
    });

    fetch(
      "https://vbj1bw1oc0.execute-api.us-west-2.amazonaws.com/dev/updatePassword",
      {
        method: "POST",
        mode: "cors",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firstName: fields.firstName,
          lastName: fields.lastName,
          username: fields.email,
          password: fields.password,
          companyUUID: fields.companyUUID,
          companyName: fields.companyName,
          environment: fields.environment,
        }),
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        console.log(data.err);
        data.err
          ? this.setState({
              errMsg: "Your request cannot be processed at this time",
              message: true,
              loading: false,
            })
          : window.location.replace(
              "https://app.postured.io/login?redirect=true"
            );
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loading: false,
        });
      });
  }


  render() {
    const { firstName, lastName, password } = this.props.fields;

    const { handleSubmit } = this.props;

    const fullname = this.props.fields.firstName + " " + this.props.fields.lastName

    console.log(fullname)
    return (
      <div className="row">
        <div className="col-md-6">
          <h2 className="account__logo-accent">Let's secure your account</h2>
          <br />
          <h3 className="account__subhead">
            Create a password
          </h3>
          <form
            className="form"
            id="change-password"
            onSubmit={handleSubmit(this.onSubmit.bind(this))}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            {this.state.message ? (
              <ErrorAlert
                level="danger"
                msg={this.state.errMsg}
                /*"Your password has already been set"*/ alertTag={"Error"}
              />
            ) : null}
            <div
              className="form__form-group-field"
              style={{ marginBottom: "-26px" }}
            >
              <Field
                id="firstName"
                name="firstName"
                value={firstName}
                component={render_field}
                type="text"
                placeholder="First Name"
                // onChange={this.props.handleChange}
                onChange={(evt) => evt.preventDefault()}
                defaultValue={firstName}
              />
            </div>

            <div
              className="form__form-group-field"
              style={{ marginBottom: "-26px" }}
            >
              <Field
                id="lastName"
                name="lastName"
                value={lastName}
                component={render_field}
                type="text"
                placeholder="Last Name"
                // onChange={this.props.handleChange}
                onChange={(evt) => evt.preventDefault()}
                defaultValue={lastName}
              />
            </div>

            <div
              className="form__form-group-field"
              style={{ marginBottom: "-10px" }}
            >
              <Field
                id="password"
                name="password"
                value={password}
                component={render_field}
                type="password"
                placeholder="Password"
                onChange={this.props.handleChange}
                defaultValue={password}
              />
            </div>

            <div
              className="form__form-group-field"
              style={{ marginBottom: "-10px" }}
            >
              <Field
                id="confirmPassword"
                name="confirmPassword"
                value={undefined}
                component={render_field}
                type="password"
                placeholder="Confirm Password"
                onChange={this.props.handleChange}
                defaultValue={undefined}
              />
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                alignContent: "center",
                width: "100%",
                marginLeft: "-30px",
                justifyContent: "flex-start",
                paddingTop: "20px"
              }}
            >
              <span className="finalized-arrow">
                <LeftArrow
                  style={{ fill: "#AEB8C4", verticalAlign: "middle" }}
                  onClick={() => {
                    this.props.back();
                  }}
                />
              </span>
              {this.state.loading ? (
                <button
                  className="loadingBtn"
                  style={{ cursor: "progress"}}
                  type="button"
                  disabled={this.state.loading}
                >
                  {" "}
                  Loading Your Environment...
                </button>
              ) : (
                <button
                  className="onBoardingBtn"
                  style={{ cursor: "pointer", width: "150px"}}
                >
                  Next
                </button>
              )}
            </div>
          </form>
        </div>
        
        <div className="col-md-6 align-self-center">
            <div style={{marginTop: "130px"}}></div>
            <img src={ LaptopImg } style={{ width: "100%"}}/>
        </div>
      </div>
    );
  }
}

function validate(values) {
  // console.log(values.changepassword)
  let errors = {};
  // checks if password has at least 1 uppercase letter, 1 lowercase, 1 digit, minimum length of 8
  //let pwd = (/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/);
  let lowercase = /(?=.*?[a-z])/;
  let uppercase = /(?=.*?[A-Z])/;
  let number = /(?=.*?[0-9])/;
  let specialChar = /[-!$\\#@%^&*()_+|~=`{}\[\]:";'<>?,.\/]/;
  let length = /.{8,}/;

  if (!values.firstName) {
    errors.firstName = "Enter your First Name";
  }

  if (!values.lastName) {
    errors.lastName = "Enter your Last Name";
  }

  /*if (!pwd.test(values.password)) {
        errors.password = "Enter a valid password";
        //console.log(errors.password)
    }*/

  if (!lowercase.test(values.password)) {
    errors.password = "Password must include a lowercase letter";
  }

  if (!uppercase.test(values.password)) {
    errors.password = "Password must include an uppercase letter";
  }

  if (!number.test(values.password)) {
    errors.password = "Password must include at least one digit";
  }

  if (!length.test(values.password)) {
    errors.password = "Password must be longer than 8 characters";
  }

  if (!specialChar.test(values.password)) {
    errors.password = "Password must contain a special character";
  }

  if (values.password !== values.confirmPassword) {
    errors.confirmPassword = "Password and Confirm Password do not match";
  }

  return errors;
}

export default withRouter(
  reduxForm({
    form: "finalizeForm",
    validate,
  })(ChangePassword)
);



// WEBPACK FOOTER //
// ./src/pages/account/register/components/ChangePassword.js